import React, { useMemo } from 'react';
import { FmlxButton, FmlxTab } from 'fmlx-common-ui';
import { useRMDispatch } from 'redux/hooks';
import {
  fetchActiveUnarchiveJobResultsThunk,
  fetchArchivedExperimentsThunk,
  fetchUndismissedUnarchivingJobResultsThunk,
} from 'redux/thunks/unarchiving';
import { UnarchivePreviewTable } from './unarchivePreviewTable';
import { UnarchiveResultsTable } from './unarchiveResultsTable';
import { EUnarchivePreviewTab, UnarchivePreviewProps } from './constants';

export const UnarchivePreview = (props: UnarchivePreviewProps) => {
  const {
    selectedTaskIds,
    selectedTab,
    onSelectedTabChange,
    resultsJobId,
    onUnarchiveSuccess,
  } = props;
  const dispatch = useRMDispatch();
  const isResultsTab = selectedTab === EUnarchivePreviewTab.Results;

  const onTabChange = (value: { index: number | string }) => {
    const parsed = typeof value.index === 'number' ? value.index : Number(value.index);
    if (Number.isNaN(parsed)) {
      return;
    }
    onSelectedTabChange(parsed);
  };

  const onRefreshClick = () => {
    if (selectedTab === EUnarchivePreviewTab.Preview) {
      dispatch(fetchArchivedExperimentsThunk(selectedTaskIds));
      return;
    }

    if (resultsJobId) {
      dispatch(fetchActiveUnarchiveJobResultsThunk(resultsJobId));
      return;
    }

    dispatch(fetchUndismissedUnarchivingJobResultsThunk());
  };

  const items = useMemo(
    () => [
      {
        title: 'Preview',
        content: (
          <UnarchivePreviewTable
            selectedTaskIds={selectedTaskIds}
            onUnarchiveSuccess={onUnarchiveSuccess}
          />
        ),
        icon: undefined,
        disabled: false,
      },
      {
        title: 'Results',
        content: <UnarchiveResultsTable />,
        icon: undefined,
        disabled: false,
      },
    ],
    [selectedTaskIds, onUnarchiveSuccess],
  );

  return (
    <>
      <FmlxTab
        type={FmlxTab.Type.CONTAINED}
        items={items}
        selectedTab={selectedTab}
        variant={FmlxTab.Variant.STANDARD}
        onChange={onTabChange}
      />
      <div className="absolute right-0 m-2 flex flex-row gap-2">
        <FmlxButton
          disabled={!isResultsTab && selectedTaskIds.length === 0}
          size={FmlxButton.Size.SMALL}
          label="Refresh"
          onClick={onRefreshClick}
        />
      </div>
    </>
  );
};
